module.exports = __webpack_public_path__ + "static/lframe-cards-867528a935d8c49d5b684dcf191031dd.png";